import { refs, domReady, dispatchEvent } from '../modules/utils.js';

class IconClose extends HTMLElement {
  static get observedAttributes() {
    return [];
  }

  attributeChangedCallback(name, oldValue, newValue) { }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
  }

  #listeners() {
    this.addEventListener('click', (e) => dispatchEvent('iconclose:click'));
  }
}

customElements.define('icon-close', IconClose);
